module.exports = __webpack_public_path__ + "bubble.3d3eea9.glb";